import { eventReportOptionValues } from "@ac-expo/api-types";
import { z } from "zod";

export const EventReportSchema = z
  .object({
    reportOption: z.enum(eventReportOptionValues),
    otherReason: z
      .string()
      .max(
        1000,
        "Le texte de la description ne doit pas dépasser 1000 caractères"
      )
      .optional(),
  })
  .superRefine((data, ctx) => {
    if (data.reportOption === "other" && !data.otherReason) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["otherReason"],
      });
    }
  });

export const defaultEventReportValues: EventReportForm = {
  reportOption: "fakeEvent",
  otherReason: undefined,
};

export type EventReportForm = z.infer<typeof EventReportSchema>;
